export const CycleAudienceType = {
    ENTIRE_COMPANY: 'EntireCompany',
    FILTER_BY_ATTRIBUTES: 'FilterByAttributes',
} as const;

export type CycleAudienceTypeValue = (typeof CycleAudienceType)[keyof typeof CycleAudienceType];

export const EvaluationType = {
    EVALUATION_360: 'Evaluation360',
    SELF_EVALUATION: 'SelfEvaluation',
    MANAGER_EVALUATION: 'ManagerEvaluation',
} as const;

export type EvaluationTypeKey = keyof typeof EvaluationType;
export type EvaluationTypeValue = (typeof EvaluationType)[EvaluationTypeKey];

export const CycleEvaluationStatus = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    DRAFT: 'Draft',
} as const;

export type CycleEvaluationStatusKey = keyof typeof CycleEvaluationStatus;
export type CycleEvaluationStatusValue =
    (typeof CycleEvaluationStatus)[keyof typeof CycleEvaluationStatus];
